import { Helmet } from 'react-helmet-async';
import { MetaParts } from 'shared/components/HelmetMetaTags';
import { FRONT_END_BASE_URL } from 'shared/constants/common';
import { useGetThemeColor } from 'shared/hooks/useGetThemeColor';

export type HelmetProps = {
	title?: any;
	description?: any;
	ogtype?: string;
	ogurl?: string;
	ogimage?: string;
	is404?: boolean;
	is301?: boolean;
	redirectUrl?: string;
};

export const HelmetMetaTags = ({
	title = 'BETFAN',
	description = 'BETFAN',
	ogtype = 'website',
	ogurl,
	ogimage,
	is404,
	is301,
	redirectUrl,
}: HelmetProps) => {
	const canonicalLink = window.location.href.split('?')[0];
	const resolvedUrl = ogurl ? `${FRONT_END_BASE_URL}${ogurl}` : window.location.href;
	const themeColor = useGetThemeColor();
	return (
		<Helmet>
			<title>{title}</title>
			{MetaParts.AppleItunesApp()}
			<meta name="description" content={description} />
			<meta name="og:description" content={description} />
			<meta property="og:title" content={title} />
			<meta property="og:type" content={ogtype} />
			<meta property="og:url" content={resolvedUrl} />
			<meta property="og:image" content={ogimage ? ogimage : `${FRONT_END_BASE_URL}/favicon.ico`} />
			<link rel="canonical" href={canonicalLink} />

			<link rel="stylesheet" media="all and (orientation:portrait)" href="" />
			<meta charSet="utf-8" />
			<meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0, viewport-fit=cover" />
			<meta name="theme-color" content={themeColor} />
			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-status-bar-style" content="translucent" />
			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
			{is404 && <meta name="prerender-status-code" content="404" />}
			{is404 && <meta name="robots" content="noindex" />}
			{is301 && <meta name="prerender-status-code" content="301" />}
			{is301 && <meta name="prerender-header" content={`Location: ${redirectUrl}`} />}
		</Helmet>
	);
};
